import React from 'react';
import classNames from 'classnames';

interface Props {
  slug?: string;
  narrow?: boolean;
  caption?: string;
  jumplinkSlug?: string;
}

export default class VideoEmbed extends React.Component<Props, null> {

  videoUrl() {
    return `https://www.youtube.com/embed/${this.props.slug}`;
  }

  render() {
    if (!this.props.slug) return null;

    const classes = classNames(
      'video-embed',
      { 'video-embed--narrow': this.props.narrow },
    );

    return (
      <div
        className={classes}
        id={this.props.jumplinkSlug || null}
      >
        <div className="video-embed__inner" itemProp="videoObject" itemScope itemType="http://schema.org/VideoObject">
          <meta itemProp="embedUrl" content={this.videoUrl()} />
          <iframe
            src={this.videoUrl()}
            title={this.props.caption}
            frameBorder="0"
            allowFullScreen
          />
        </div>
        {this.props.caption &&
          <div className="video-embed__caption">
            {this.props.caption}
          </div>
        }
      </div>
    );
  }
}
